import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=5b2181f2&scoped=true"
import script from "./ToggleBox.vue?vue&type=script&lang=js"
export * from "./ToggleBox.vue?vue&type=script&lang=js"
import style0 from "./ToggleBox.vue?vue&type=style&index=0&id=5b2181f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2181f2",
  null
  
)

export default component.exports